// Header customization for product, shop, and home pages
(function() {
  var isProductPage = document.body.classList.contains('template-product');
  var isCollectionPage = document.body.classList.contains('template-collection');
  var isHomePage = document.body.classList.contains('template-index') || document.querySelector('.tmm-product-page');
  
  if (!isProductPage && !isCollectionPage && !isHomePage) return;
  
  // Watch and remove custom TMM header on home page
  if (isHomePage) {
    console.log('[TMM] Home page - watching for custom header');
    
    // Watch for tmm-nav being added to DOM
    var observer = new MutationObserver(function(mutations) {
      var tmmNav = document.getElementById('tmm-nav');
      if (tmmNav) {
        console.log('[TMM] Custom header detected, removing');
        tmmNav.remove();
      }
    });
    
    // Start watching the body
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Also remove immediately if it already exists
    var tmmNav = document.getElementById('tmm-nav');
    if (tmmNav) {
      console.log('[TMM] Removing existing custom header');
      tmmNav.remove();
    }
  }
  
  // Completely disable sticky-header behavior
  customElements.whenDefined('sticky-header').then(function() {
    var stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      // Override ALL methods to do nothing
      stickyHeader.hide = function() {};
      stickyHeader.reveal = function() {};
      stickyHeader.reset = function() {};
      stickyHeader.onScroll = function() {};
      
      // Remove scroll listener
      if (stickyHeader.onScrollHandler) {
        window.removeEventListener('scroll', stickyHeader.onScrollHandler);
      }
      
      // Force header visible
      var headerSection = document.querySelector('.shopify-section-header');
      if (headerSection) {
        headerSection.classList.remove('shopify-section-header-hidden');
        headerSection.classList.add('shopify-section-header-sticky');
        headerSection.style.transform = 'translateY(0)';
      }
    }
  });
  
  // Add brand name
  var headingLink = document.querySelector('.header__heading-link');
  if (headingLink && !document.querySelector('.tmm-brand-name')) {
    var brandName = document.createElement('span');
    brandName.className = 'tmm-brand-name';
    brandName.textContent = 'THE MALE METHOD';
    headingLink.appendChild(brandName);
  }
  
  // Update menu links
  function updateMenu() {
    var menuSelectors = ['.header__inline-menu .list-menu', '.header__inline-menu ul'];
    for (var i = 0; i < menuSelectors.length; i++) {
      var menu = document.querySelector(menuSelectors[i]);
      if (menu) {
        var links = '';
        
        if (isHomePage) {
          // Home page: anchor links with Shop instead of Reviews
          links = '<li style="list-style:none"><a href="#features" style="color:#fff;text-decoration:none;font-size:1.45rem;font-weight:600;padding:0.5rem 1.25rem">Features</a></li>';
          links += '<li style="list-style:none"><a href="#ingredients" style="color:#fff;text-decoration:none;font-size:1.45rem;font-weight:600;padding:0.5rem 1.25rem">Ingredients</a></li>';
          links += '<li style="list-style:none"><button onclick="TMMFitTest.open()" style="background:none;border:none;color:#fff;text-decoration:none;font-size:1.45rem;font-weight:600;padding:0.5rem 1.25rem;cursor:pointer">Fit Test</button></li>';
          links += '<li style="list-style:none"><a href="/collections/all" style="color:#fff;text-decoration:none;font-size:1.45rem;font-weight:600;padding:0.5rem 1.25rem">Shop</a></li>';
          links += '<li style="list-style:none"><a href="#faqs" style="color:#fff;text-decoration:none;font-size:1.45rem;font-weight:600;padding:0.5rem 1.25rem">FAQs</a></li>';
        } else {
          // Product and shop pages: Home, Help, Track Order
          links = '<li style="list-style:none"><a href="/" style="color:#fff;text-decoration:none;font-size:1.45rem;font-weight:600;padding:0.5rem 1.25rem">Home</a></li>';
          links += '<li style="list-style:none"><a href="mailto:care@themalemethod.in" style="color:#fff;text-decoration:none;font-size:1.45rem;font-weight:600;padding:0.5rem 1.25rem">Help</a></li>';
          links += '<li style="list-style:none"><a href="https://www.shiprocket.in/shipment-tracking/" style="color:#fff;text-decoration:none;font-size:1.45rem;font-weight:600;padding:0.5rem 1.25rem">Track Order</a></li>';
        }
        
        menu.innerHTML = links;
        menu.style.gap = '1rem';
        break;
      }
    }
  }
  
  setTimeout(updateMenu, 100);
  setTimeout(updateMenu, 500);
  
  // Carousel image fixes (product pages only)
  if (isProductPage) {
    function fixCarousel() {
      document.querySelectorAll('.media-wrapper.loading').forEach(function(el) {
        el.classList.remove('loading');
      });
      document.querySelectorAll('use-animate:not([animate])').forEach(function(el) {
        el.setAttribute('animate', '');
      });
      document.querySelectorAll('.product__media-icon, .gallery-cursor').forEach(function(el) {
        el.style.display = 'none';
      });
    }
    setTimeout(fixCarousel, 100);
    setTimeout(fixCarousel, 500);
  }
})();
